import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_cmdk__ from "cmdk";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__dialog_mjs_a62686f1__ from "./dialog.mjs";
function Command({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command, {
        "data-slot": "command",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("bg-grayscale-darker text-foreground flex h-full w-full flex-col overflow-hidden !rounded-xl", className),
        ...props
    });
}
function CommandDialog({ title = "Command Palette", description = "Search for a command to run...", children, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_a62686f1__.Dialog, {
        ...props,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_a62686f1__.DialogHeader, {
                className: "sr-only",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_a62686f1__.DialogTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_a62686f1__.DialogDescription, {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_a62686f1__.DialogContent, {
                className: "overflow-hidden p-0",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Command, {
                    className: "[&_[cmdk-group-heading]]:text-muted-foreground **:data-[slot=command-input-wrapper]:h-12 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
                    children: children
                })
            })
        ]
    });
}
const CommandInput = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, wrapperClassName, showIcon = false, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        "data-slot": "command-input-wrapper",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex h-9 items-center border-b px-2.5", wrapperClassName),
        children: [
            showIcon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.SearchIcon, {
                className: "size-3.5 shrink-0 opacity-50"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Input, {
                ref: ref,
                "data-slot": "command-input",
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("text-[13px] focus:ring-0 border-none focus:border-none focus:outline-none flex h-[32px] pr-1  w-full rounded-md bg-transparent outline-hidden disabled:cursor-not-allowed disabled:opacity-50", className),
                ...props
            })
        ]
    }));
CommandInput.displayName = "CommandInput";
function CommandList({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.List, {
        "data-slot": "command-list",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto", className),
        ...props
    });
}
function CommandEmpty({ ...props }) {
    const { className, ...rest } = props;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Empty, {
        "data-slot": "command-empty",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("py-6 text-center text-sm text-muted-foreground", className),
        ...rest
    });
}
function CommandGroup({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Group, {
        "data-slot": "command-group",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("text-foreground [&_[cmdk-group-heading]]:text-secondary-foreground overflow-hidden [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs", className),
        ...props
    });
}
function CommandSeparator({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Separator, {
        "data-slot": "command-separator",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("bg-border -mx-1 h-px", className),
        ...props
    });
}
const CommandItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Item, {
        ref: ref,
        "data-slot": "command-item",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("data-[selected=true]:bg-grayscale-dark cursor-pointer text-foreground/[0.85] data-[selected=true]:text-foreground [&_svg:not([class*='text-'])]:text-secondary-foreground relative flex items-center gap-1 rounded-md px-2.5 py-1.5 text-sm outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className),
        ...props
    }));
CommandItem.displayName = "CommandItem";
function CommandShortcut({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        "data-slot": "command-shortcut",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("text-muted-foreground ml-auto text-xs tracking-widest", className),
        ...props
    });
}
export { Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator, CommandShortcut };
